import angular from 'angular';
import _ from 'lodash';
import UtilsService from './utilsService';

export const TALENYA_ROLE = 'TALENYA';
export const TALENT_EXPERT_ROLE = 'TE';
export const EMPLOYER_ROLE = 'EM';

export function PermissionsService($cookies) {
    const isRoleExist = (role) => {
        UtilsService.cookiesOverride($cookies);
        const userData = UtilsService.parseJSON($cookies.get('userData'));
        const roles = _.get(userData, 'roles');

        if (!roles || roles?.length === 0) {
            return false;
        }

        return roles?.indexOf(role) >= 0;
    };

    const getRecruiterId = () => {
        UtilsService.cookiesOverride($cookies);
        const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
        return _.get(userPrefs, 'entityId', null);
    };

    const isTalenyaUser = () => isRoleExist(TALENYA_ROLE);

    const isEmployerUser = () => isRoleExist(EMPLOYER_ROLE);

    const isTalentExpertUser = () => isRoleExist(TALENT_EXPERT_ROLE);

    return {
        isTalenyaUser,
        isTalentExpertUser,
        isEmployerUser,
        getRecruiterId,
    };
}

angular.module('TALENYA-FE').factory('permissions', PermissionsService);
